import * as React from 'react';
type Props = {
  className?: string;
};
export function BoxWithPencil({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-BoxWithPencil"
      className={className}
    >
      <path
        d="M28 13V10.6667C27.9995 10.1991 27.8761 9.73978 27.6421 9.33492C27.408 8.93005 27.0717 8.59385 26.6667 8.36003L17.3333 3.0267C16.9279 2.79265 16.4681 2.66943 16 2.66943C15.5319 2.66943 15.0721 2.79265 14.6667 3.0267L5.33333 8.36003C4.92835 8.59385 4.59197 8.93005 4.35795 9.33492C4.12392 9.73978 4.00048 10.1991 4 10.6667V21.3334C4.00048 21.801 4.12392 22.2603 4.35795 22.6651C4.59197 23.07 4.92835 23.4062 5.33333 23.64L14.6667 28.9734C15.0721 29.2074 15.5319 29.3306 16 29.3306C16.4681 29.3306 16.9279 29.2074 17.3333 28.9734L19.6667 27.64"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 29.3333V16"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.38672 9.33325L16.0001 15.9999L27.6134 9.33325"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 5.69336L22 12.56"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.94 19.2641C29.2986 18.9056 29.5 18.4192 29.5 17.9121C29.5 17.405 29.2986 16.9186 28.94 16.56C28.5815 16.2015 28.0952 16 27.5881 16C27.081 16 26.5947 16.2015 26.2362 16.56L21.7268 21.0717C21.5128 21.2856 21.3562 21.55 21.2714 21.8404L20.518 24.4239C20.4954 24.5014 20.4941 24.5835 20.5141 24.6616C20.5341 24.7398 20.5748 24.8111 20.6318 24.8682C20.6889 24.9252 20.7602 24.9659 20.8383 24.9859C20.9165 25.0059 20.9986 25.0046 21.076 24.982L23.6593 24.2286C23.9497 24.1437 24.2141 23.9871 24.4279 23.7731L28.94 19.2641Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
